// Module
var code = "<div id=\"root\" class=\"cart\"> <cError v-if=\"error\" :app=\"app\" :error=\"error\" :is-loading=\"isLoading\" :order=\"order\" :page=\"page\" :retargeting-url=\"retargetingUrl\" :theme=\"theme\" :url=\"url\" :utils=\"utils()\"/> </div> ";
// Exports
export default code;